import { useMutation, UseMutationResult } from 'react-query';
import { deleteTournament } from '../api/tournament';
import { QueryKeys } from '../constants';

export function useDeleteTournament(): UseMutationResult<void, unknown, number> {
    return useMutation([QueryKeys.deleteTournament], (id: number) => deleteTournament(id));
}
